// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.Restriction = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("left") || !options.hasOwnProperty("right") || !options.hasOwnProperty("op")) {
        throw "InvalidConstructorArgs - Restriction";
      }
      _.bindAll(this, "bindEnums", "unbindEnumsFromAttributes", "isValid", "equal", "toJSON");
      if (_.isString(options.op)) {
        return this.bindEnums();
      }
    },
    bindEnums: function() {
      return this.set({
        op: rjm.app.enums.comparisonOperator[this.get("op")]
      });
    },
    unbindEnumsFromAttributes: function(attributes) {
      attributes.op = attributes.op.serializedValue;
      return attributes;
    },
    isValid: function() {
      if (_(this.get('right')).isFinite()) {
        return true;
      } else {
        return !_(this.get('right')).isEmpty();
      }
    },
    equal: function(restriction) {
      if (restriction == null) {
        return false;
      }
      if (!this.get("left").equal(restriction.get("left")) || JSON.stringify(this.get("right")) !== JSON.stringify(restriction.get("right")) || this.get("op").symbols !== restriction.get("op").symbols) {
        return false;
      }
      return true;
    },
    toJSON: function() {
      var r;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      r = this.unbindEnumsFromAttributes(r);
      return r;
    },
    relations: [
      {
        type: Backbone.HasOne,
        key: "left",
        relatedModel: "rjm.model.LSColumn",
        includeInJSON: true
      }
    ]
  });

}).call(this);
